/**
 * External dependencies
 */
import React, { memo } from 'react';
import Box from '@mui/material/Box';
import { keyframes } from '@mui/material';

/**
 * Internal dependencies
 */
import svgPaths from './svg-paths';

const drawLine = keyframes`
  0% { stroke-dashoffset: 1; opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { stroke-dashoffset: 0; opacity: 0; }
`;

function CheckView(): React.ReactElement {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        overflow: 'hidden', // 確保旋轉後的溢出部分被隱藏
        bgcolor: 'background.default',
        zIndex: 10000
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          // 關鍵點：使用 transform 同時處理「中心定位」與「旋轉」
          // 並利用 scale 根據螢幕大小調整動畫縮放比
          transform: {
            xs: 'translate(-50%, -50%) rotate(23.17deg) scale(0.6)', // 手機版縮小
            sm: 'translate(-50%, -50%) rotate(23.17deg) scale(0.8)', // 平板版
            md: 'translate(-50%, -50%) rotate(23.17deg) scale(1)' // 電腦版
          },
          // 讓容器寬度隨螢幕調整，但保持最小尺寸以維持線條形狀
          width: { xs: '150vw', md: '1423.86px' },
          height: { xs: '150vw', md: '1226.6px' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
          transition: 'transform 0.3s ease' // 縮放時平滑過渡
        }}
      >
        <svg
          width="100%"
          height="100%"
          fill="none"
          viewBox="0 0 1430 1233"
          // 關鍵點：preserveAspectRatio 確保 SVG 縮放時像 CSS cover 一樣填滿
          preserveAspectRatio="xMidYMid slice"
        >
          <Box
            component="path"
            d={svgPaths.p11792e00}
            sx={{
              stroke: 'url(#paint0_linear_hero)',
              strokeMiterlimit: 10,
              strokeWidth: { xs: 20, md: 10 }, // 手機版線條可以加粗一點才看得見
              strokeDasharray: 1,
              strokeDashoffset: 1,
              animation: `${drawLine} 1s ease-in-out infinite`
            }}
            pathLength="1"
          />
          <defs>
            <linearGradient
              id="paint0_linear_hero"
              x1="128.107"
              x2="1256.11"
              y1="949.258"
              y2="618.258"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E9B992" />
              <stop offset="0.355769" stopColor="#C6DDB4" />
              <stop offset="1" stopColor="#C9C1D6" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
    </Box>
  );
}

export default memo(CheckView);
